
export enum AppStep {
  WELCOME = 'WELCOME',
  BRAND = 'BRAND',
  ITEMS = 'ITEMS',
  CONFIRM = 'CONFIRM',
  BUNDLE = 'BUNDLE',
  SUCCESS = 'SUCCESS',
  DASHBOARD = 'DASHBOARD',
  ADMIN_LOGIN = 'ADMIN_LOGIN',
  ADMIN_PORTAL = 'ADMIN_PORTAL',
  MANAGER_LOGIN = 'MANAGER_LOGIN',
  MANAGER_PROFILE = 'MANAGER_PROFILE',
  LOGIN = 'LOGIN',
  PROPOSAL = 'PROPOSAL',
  PROPOSAL_BRAND = 'PROPOSAL_BRAND'
}

export enum WorkflowStage {
  F_AND_B = 'Food & Beverage',
  F_AND_P = 'Finance & Planning',
  DIGITAL_SALES = 'Digital Sales',
  COMPLETED = 'Completed',
  RETURNED = 'Returned to Manager'
}

export enum SubmissionType {
  CAMPAIGN = 'Campaign',
  PROPOSAL = 'Proposal'
}

export enum AdminView {
  DASHBOARD = 'DASHBOARD',
  CAMPAIGNS = 'CAMPAIGNS',
  SUBMISSIONS = 'SUBMISSIONS',
  PROPOSALS = 'PROPOSALS',
  TABLE = 'TABLE',
  REPORTS = 'REPORTS',
  ANALYTICS = 'ANALYTICS',
  COMMUNITY = 'COMMUNITY',
  MENU_BUILDER = 'MENU_BUILDER',
  SETTINGS = 'SETTINGS',
  USERS = 'USERS',
  PROFILE = 'PROFILE',
  TRACE = 'TRACE',
  // Action permissions (not pages)
  SUBMIT_SUBMISSIONS = 'SUBMIT_SUBMISSIONS',
  SUBMIT_PROPOSALS = 'SUBMIT_PROPOSALS',
  SUBMIT_CAMPAIGNS = 'SUBMIT_CAMPAIGNS',
  // Manager-specific views
  MANAGER_DASHBOARD = 'MANAGER_DASHBOARD', // Unified Manager Dashboard (Overview + History tabs)
  // Admin-only views
  MANAGERS_DASHBOARD = 'MANAGERS_DASHBOARD', // Admin view to browse any manager's dashboard
}

export enum SubmissionStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  EXPORTED = 'Exported',
  NEEDS_REVISION = 'Needs Revision'
}

export enum CampaignStatus {
  ACTIVE = 'Active',
  PLANNED = 'Planned',
  CLOSED = 'Closed'
}

export enum UserRole {
  ADMIN = 'Admin',
  SEO = 'SEO',
  DEPT_USER = 'Department User',
  MANAGER = 'Manager'
}

export enum Department {
  FB = 'Food & Beverage',
  FP = 'Finance & Planning',
  DS = 'Digital Sales',
  ALL = 'All Departments',
  OPERATIONS = 'Operations'
}
